<template>
  <v-container v-if="isLoading || isCoreLoading" class="pa-0" fill-height>
    <v-row align="center" justify="center">
      <v-progress-circular
        :rotate="-90"
        :size="100"
        :width="15"
        :value="printLoading"
        color="blue">{{ printLoading }}%</v-progress-circular>
    </v-row>
  </v-container>
  <div v-else class="pm-container">
    <iframe :src="printSource" style="min-height:400px;">
      <p>このデバイスではPDFのプレビュー機能をお使いになれません。</p>
    </iframe>
  </div>
</template>
<script>
import template from '@/assets/templates/application'
export default {
  name: 'pdfMakerPane',
  props: [
    'form',
    'status'
  ],
  data () {
    return {
      config: {
        status: {
          loading: true
        }
      },
      store: {
        document: {},
        src: ''
      }
    }
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init: function () {
    },
    update: function () {
      this.$set(this.config.status, 'loading', 0)
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.axios.post(`${this.$url.api}apply/doc/review`, {
          data: this.getDocData()
        }, {
          headers: {
            'firebase-token': token
          },
          onUploadProgress: (e) => {
            this.$set(this.config.status, 'loading', Math.ceil(e.loaded / e.total * 100))
          }
        }).then(res => {
          if (res.data && res.data.success) {
            this.$set(this.config.status, 'loading', false)
            this.$set(this.store, 'src', res.data.data)
          }
        })
      })
    },
    getForm: function () {
      return this.$props.form || {}
    },
    getDocData: function () {
      return template.publish(this.getForm())
    }
  },
  computed: {
    isLoading () {
      return Number.isFinite(this.config.status.loading)
    },
    isCoreLoading () {
      return this.$props.status && Number.isFinite(this.$props.status.loading)
    },
    printSource () {
      return this.store.src
    },
    printLoading () {
      if (Number.isFinite(this.config.status.loading)) {
        return this.config.status.loading
      } else if (this.$props.status && Number.isFinite(this.config.status.loading)) {
        return this.$props.status.loading
      } else {
        return ''
      }
    },
    getFormItem () {
      return this.$props.form ? this.$props.form : {}
    }
  }
}
</script>
